import type { FC, ReactNode } from 'react'

import { CalendarPlus } from 'lucide-react'
import { cn } from '@/lib/utils'
import { buttonStyles } from '@/lib/button-styles'
import { calendarFileName, googleCalendarUrl } from '@/lib/calendar'

interface CalendarButtonsProps {
    tone?: 'default' | 'inverted'
    className?: string
}

const CalendarButtons: FC<CalendarButtonsProps> = ({ tone = 'default', className }): ReactNode => {
    const inverted = tone === 'inverted'

    return (
        <div className={cn('flex flex-col gap-3 sm:flex-row sm:flex-wrap', className)}>
            <a
                href={googleCalendarUrl()}
                target='_blank'
                rel='noopener noreferrer'
                className={buttonStyles({ variant: inverted ? 'light' : 'primary' })}
            >
                <CalendarPlus aria-hidden='true' />
                Google Agenda
                <span className='sr-only'>(s’ouvre dans un nouvel onglet)</span>
            </a>

            <a
                href='/api/agenda'
                download={calendarFileName}
                className={buttonStyles({ variant: inverted ? 'outline-light' : 'outline' })}
            >
                <CalendarPlus aria-hidden='true' />
                Apple, Outlook et autres
            </a>
        </div>
    )
}

export default CalendarButtons
